import * as actionTypes from '../actions/actionTypes';

import { updateState } from '../../lib/StateHelper';

const initialState = {
  isDirty: false
};

const alertReducer = (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.FORM_ISDIRTY: {
      return updateState(state, { isDirty: action.isDirty });
    }
    default: {
      return state;
    }
  }
};

export default alertReducer;